import React, { useEffect, useState, createContext, useContext } from 'react';
// JENIS KEANGGOTAAN - Sesuai Juklak BAB II Pasal 3
export type MembershipType = 'INDIVIDU_PELAJAR' // Pelajar/Mahasiswa/Student - GRATIS
| 'INDIVIDU_UMUM' // Profesional, ASN, TNI, Polri - Rp 500.000
| 'ORGANISASI_KOMUNITAS' // Komunitas/Kelompok Pengguna - Rp 2.500.000
| 'ORGANISASI_PENDIDIKAN' // Sekolah, Universitas - Rp 5.000.000
| 'ORGANISASI_NIRLABA' // NGO, Yayasan - Rp 3.000.000
| 'ORGANISASI_ASOSIASI' // Asosiasi Profesional - Rp 4.000.000
| 'ORGANISASI_PENELITIAN' // Lembaga Penelitian - Rp 5.000.000
| 'ORGANISASI_PEMERINTAH' // Instansi Pemerintah - Rp 10.000.000
| 'BADAN_USAHA_MIKRO' // Usaha Mikro - Rp 1.000.000
| 'BADAN_USAHA_KECIL' // Usaha Kecil - Rp 3.000.000
| 'BADAN_USAHA_MENENGAH' // Usaha Menengah - Rp 7.500.000
| 'BADAN_USAHA_BESAR' // Perusahaan Besar - Rp 15.000.000
| 'BADAN_USAHA_STARTUP' // Startup/Rintisan - Rp 2.000.000
| 'MITRA_ASOSIASI'; // Mitra Asosiasi - GRATIS (MoU)
// STATUS KEANGGOTAAN - Sesuai Juklak BAB VII Pasal 23
export type MembershipStatus = 'Pending' // Calon anggota sedang dalam proses verifikasi
| 'Active' // Anggota telah disahkan dan iuran dibayar
| 'Pending_Renewal' // Mengajukan perpanjangan, menunggu verifikasi
| 'Expired' // Keanggotaan berakhir, belum diperpanjang
| 'Suspended' // Ditangguhkan karena pelanggaran/tunggakan
| 'Terminated'; // Dihentikan permanen oleh Komite Pusat
// USER ROLES - Untuk sistem akses
export type UserRole = 'super_admin' // Admin Sistem
| 'komite_pusat' // Komite Pusat ATIOS
| 'ketua_chapter' // Ketua Chapter Regional
| 'ketua_student_chapter' // Ketua Student Chapter
| 'koordinator_acara' // Koordinator Acara
| 'bendahara' // Bendahara
| 'anggota_individu' // Anggota Individu (Pelajar/Umum)
| 'anggota_organisasi' // Anggota Organisasi
| 'anggota_badan_usaha' // Anggota Badan Usaha
| 'mitra_asosiasi'; // Mitra Asosiasi
export type ChapterType = 'regional' | 'student' | 'tematik';
export interface User {
  id: string;
  nama: string;
  email: string;
  role: UserRole;
  // Data Keanggotaan
  jenisKeanggotaan?: MembershipType;
  statusKeanggotaan?: MembershipStatus;
  nomorAnggota?: string;
  tanggalBergabung?: string;
  tanggalBerakhir?: string;
  // Data Pribadi/Organisasi
  avatar?: string;
  noKTP?: string;
  noNPWP?: string;
  alamat?: string;
  kota?: string;
  provinsi?: string;
  telepon?: string;
  // Data Chapter
  chapterId?: string;
  namaChapter?: string;
  jenisChapter?: ChapterType;
  // Data Khusus
  namaOrganisasi?: string; // Untuk Organisasi/Badan Usaha
  nomorIndukMahasiswa?: string; // Untuk Pelajar/Mahasiswa
  namaUniversitas?: string; // Untuk Pelajar/Mahasiswa
  jabatan?: string; // Untuk Organisasi/Badan Usaha
  // Permissions
  permissions: string[];
  // Iuran
  iuranTahunan?: number;
  statusPembayaran?: 'Lunas' | 'Belum Bayar' | 'Menunggak';
}
interface AuthContextType {
  user: User | null;
  login: (email: string, password: string, role: UserRole) => Promise<void>;
  logout: () => void;
  isAuthenticated: boolean;
  hasPermission: (permission: string) => boolean;
  hasRole: (roles: UserRole | UserRole[]) => boolean;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
// MOCK USERS - Sesuai Juklak ATIOS
const MOCK_USERS: Record<UserRole, User> = {
  super_admin: {
    id: '1',
    nama: 'Admin Sistem',
    email: 'admin@atios.or.id',
    role: 'super_admin',
    avatar: 'AS',
    permissions: ['*']
  },
  komite_pusat: {
    id: '2',
    nama: 'Siti Nurhaliza',
    email: 'siti@atios.or.id',
    role: 'komite_pusat',
    avatar: 'SN',
    permissions: ['organisasi.lihat', 'organisasi.kebijakan.setuju', 'chapter.lihat', 'chapter.laporan.lihat', 'acara.lihat', 'acara.setuju', 'keuangan.lihat', 'anggota.lihat', 'anggota.verifikasi', 'anggota.setujui']
  },
  ketua_chapter: {
    id: '3',
    nama: 'Budi Santoso',
    email: 'budi@atios.or.id',
    role: 'ketua_chapter',
    jenisKeanggotaan: 'INDIVIDU_UMUM',
    statusKeanggotaan: 'Active',
    nomorAnggota: 'ATI-2025-001234',
    avatar: 'BS',
    chapterId: '1',
    namaChapter: 'Jakarta Tech Community',
    jenisChapter: 'regional',
    tanggalBergabung: '2024-01-01',
    tanggalBerakhir: '2025-12-31',
    iuranTahunan: 500000,
    statusPembayaran: 'Lunas',
    permissions: ['chapter.lihat', 'chapter.kelola', 'chapter.anggota.lihat', 'chapter.anggota.kelola', 'chapter.acara.buat', 'chapter.acara.kelola', 'chapter.laporan.lihat']
  },
  ketua_student_chapter: {
    id: '4',
    nama: 'Andi Wijaya',
    email: 'andi@atios.or.id',
    role: 'ketua_student_chapter',
    jenisKeanggotaan: 'INDIVIDU_PELAJAR',
    statusKeanggotaan: 'Active',
    nomorAnggota: 'ATI-2025-STD-001',
    avatar: 'AW',
    chapterId: '2',
    namaChapter: 'UI Student Chapter',
    jenisChapter: 'student',
    namaUniversitas: 'Universitas Indonesia',
    nomorIndukMahasiswa: '1806123456',
    tanggalBergabung: '2024-09-01',
    tanggalBerakhir: '2025-08-31',
    iuranTahunan: 0,
    statusPembayaran: 'Lunas',
    permissions: ['chapter.lihat', 'chapter.kelola', 'chapter.anggota.lihat', 'chapter.anggota.kelola', 'chapter.acara.buat', 'chapter.acara.kelola', 'chapter.laporan.lihat', 'chapter.student.buat']
  },
  koordinator_acara: {
    id: '5',
    nama: 'Ahmad Rizki',
    email: 'ahmad@atios.or.id',
    role: 'koordinator_acara',
    jenisKeanggotaan: 'INDIVIDU_UMUM',
    statusKeanggotaan: 'Active',
    nomorAnggota: 'ATI-2025-002345',
    avatar: 'AR',
    tanggalBergabung: '2024-03-15',
    tanggalBerakhir: '2025-03-14',
    iuranTahunan: 500000,
    statusPembayaran: 'Lunas',
    permissions: ['acara.lihat', 'acara.buat', 'acara.kelola', 'acara.pendaftaran.lihat', 'acara.pendaftaran.kelola', 'acara.sertifikat.terbitkan']
  },
  bendahara: {
    id: '6',
    nama: 'Dewi Lestari',
    email: 'dewi@atios.or.id',
    role: 'bendahara',
    jenisKeanggotaan: 'INDIVIDU_UMUM',
    statusKeanggotaan: 'Active',
    nomorAnggota: 'ATI-2025-003456',
    avatar: 'DL',
    tanggalBergabung: '2024-02-01',
    tanggalBerakhir: '2025-01-31',
    iuranTahunan: 500000,
    statusPembayaran: 'Lunas',
    permissions: ['keuangan.lihat', 'keuangan.pembayaran.lihat', 'keuangan.pembayaran.kelola', 'keuangan.invoice.buat', 'keuangan.invoice.kelola', 'keuangan.laporan.lihat', 'keuangan.laporan.buat']
  },
  anggota_individu: {
    id: '7',
    nama: 'John Doe',
    email: 'john@atios.or.id',
    role: 'anggota_individu',
    jenisKeanggotaan: 'INDIVIDU_UMUM',
    statusKeanggotaan: 'Active',
    nomorAnggota: 'ATI-2025-004567',
    avatar: 'JD',
    chapterId: '1',
    namaChapter: 'Jakarta Tech Community',
    jenisChapter: 'regional',
    tanggalBergabung: '2025-01-01',
    tanggalBerakhir: '2025-12-31',
    iuranTahunan: 500000,
    statusPembayaran: 'Lunas',
    kota: 'Jakarta',
    provinsi: 'DKI Jakarta',
    permissions: ['profil.lihat', 'profil.ubah', 'acara.lihat', 'acara.daftar', 'manfaat.lihat', 'lowongan.lihat', 'lowongan.lamar', 'pembayaran.lihat', 'pembayaran.bayar', 'chapter.gabung', 'forum.akses']
  },
  anggota_organisasi: {
    id: '8',
    nama: 'PT Tech Indonesia',
    email: 'contact@techindonesia.com',
    role: 'anggota_organisasi',
    jenisKeanggotaan: 'ORGANISASI_PENDIDIKAN',
    statusKeanggotaan: 'Active',
    nomorAnggota: 'ATI-2025-ORG-001',
    avatar: 'TI',
    namaOrganisasi: 'PT Tech Indonesia',
    tanggalBergabung: '2025-01-01',
    tanggalBerakhir: '2025-12-31',
    iuranTahunan: 5000000,
    statusPembayaran: 'Lunas',
    kota: 'Jakarta',
    provinsi: 'DKI Jakarta',
    permissions: ['profil.lihat', 'profil.ubah', 'acara.lihat', 'acara.daftar', 'acara.sponsor', 'manfaat.lihat', 'manfaat.organisasi', 'lowongan.pasang', 'lowongan.lihat', 'lowongan.kelola', 'pembayaran.lihat', 'pembayaran.bayar', 'anggota.bulk.daftar', 'chapter.buat', 'direktori.akses']
  },
  anggota_badan_usaha: {
    id: '9',
    nama: 'CV Digital Solutions',
    email: 'info@digitalsolutions.id',
    role: 'anggota_badan_usaha',
    jenisKeanggotaan: 'BADAN_USAHA_KECIL',
    statusKeanggotaan: 'Active',
    nomorAnggota: 'ATI-2025-BIZ-001',
    avatar: 'DS',
    namaOrganisasi: 'CV Digital Solutions',
    tanggalBergabung: '2025-01-01',
    tanggalBerakhir: '2025-12-31',
    iuranTahunan: 3000000,
    statusPembayaran: 'Lunas',
    kota: 'Bandung',
    provinsi: 'Jawa Barat',
    permissions: ['profil.lihat', 'profil.ubah', 'acara.lihat', 'acara.daftar', 'acara.sponsor', 'manfaat.lihat', 'manfaat.badan_usaha', 'lowongan.pasang', 'lowongan.lihat', 'lowongan.kelola', 'pembayaran.lihat', 'pembayaran.bayar', 'anggota.bulk.daftar', 'layanan.strategis', 'branding.akses']
  },
  mitra_asosiasi: {
    id: '10',
    nama: 'Tech Partner Corp',
    email: 'partner@techcorp.com',
    role: 'mitra_asosiasi',
    jenisKeanggotaan: 'MITRA_ASOSIASI',
    statusKeanggotaan: 'Active',
    nomorAnggota: 'ATI-2025-PTR-001',
    avatar: 'TP',
    namaOrganisasi: 'Tech Partner Corp',
    tanggalBergabung: '2025-01-01',
    tanggalBerakhir: '2026-12-31',
    iuranTahunan: 0,
    statusPembayaran: 'Lunas',
    permissions: ['profil.lihat', 'acara.lihat', 'acara.kolaborasi', 'forum.akses_terbatas', 'publikasi.sesuai_mou']
  }
};
export function AuthProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [user, setUser] = useState<User | null>(null);
  useEffect(() => {
    const storedUser = localStorage.getItem('atios_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);
  const login = async (email: string, password: string, role: UserRole) => {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    const mockUser = MOCK_USERS[role];
    // Validate email matches the selected role
    if (!mockUser || mockUser.email !== email) {
      throw new Error('Email tidak sesuai dengan peran yang dipilih');
    }
    // For demo purposes, accept any non-empty password
    if (!password || password.trim() === '') {
      throw new Error('Kata sandi tidak boleh kosong');
    }
    // Login successful
    setUser(mockUser);
    localStorage.setItem('atios_user', JSON.stringify(mockUser));
  };
  const logout = () => {
    setUser(null);
    localStorage.removeItem('atios_user');
  };
  const hasPermission = (permission: string): boolean => {
    if (!user) return false;
    if (user.permissions.includes('*')) return true;
    return user.permissions.includes(permission);
  };
  const hasRole = (roles: UserRole | UserRole[]): boolean => {
    if (!user) return false;
    const roleArray = Array.isArray(roles) ? roles : [roles];
    return roleArray.includes(user.role);
  };
  return <AuthContext.Provider value={{
    user,
    login,
    logout,
    isAuthenticated: !!user,
    hasPermission,
    hasRole
  }} data-id="element-455">
      {children}
    </AuthContext.Provider>;
}
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}